import React from 'react';
import './styles.scss'

const Body = ({ children }) => (
    <main>
        {children}
    </main>
);

export default Body;
